import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import React from "react";

export default class Vestiging extends DatabaseModel implements DatabaseModelElement {
  static CreateModel(model: any): Vestiging {
    const vestiging = new Vestiging();
    Object.keys(model).forEach((key) => {
      // @ts-ignore
      vestiging[key] = model[key];
    });
    return vestiging;
  }

  static modelName = "Vestigingen";
}
